import { render, staticRenderFns } from "./PaymentStatusComponent.vue?vue&type=template&id=4cefee05&"
import script from "./PaymentStatusComponent.vue?vue&type=script&lang=js&"
export * from "./PaymentStatusComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports